<div>

     <div class="form-container">
        <form [formGroup]="transferCallForm" data-cy="transfer-call-menu" class="gh-dd-form transfer-form">
            <formly-form
                [form]="transferCallForm"
                [fields]="transferCallFields"
                [model]="transferCallModel"
                class="formly-phone-input"
                (keyup)="filterDirectoryByPhoneNumber($event.target.value)"
            >
            </formly-form>
        </form>
        <form
            [formGroup]="searchDirectoryForm"
            *ngIf="showLendioDirectory && !lendioDirectoryIsProcessing">
            <mat-form-field style="width: 340px;">
                <mat-label>Search Directory</mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="fullName"
                >
            </mat-form-field>
        </form>
    </div>

    <div *ngIf="!showLendioDirectory" class="load-directory-container">
        <button mat-flat-button (click)="loadLendioDirectory()" class="load-directory-button">
            Load Lendio Directory
        </button>
    </div>

    <div *ngIf="showLendioDirectory && lendioDirectoryIsProcessing" class="loading-directory-container">
        <mat-card class="loading-directory-mat-card">
            Loading Directory...
        </mat-card>
    </div>

    <div *ngIf="showLendioDirectory && !lendioDirectoryIsProcessing" class="directory-table-window">
        
        <table
            mat-table
            [dataSource]="dataSource"
            [trackBy]="directoryTrackBy">
            
            <ng-container matColumnDef="fullName">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let lenderUser"> {{ lenderUser.fullName }} </td>
            </ng-container>

            <ng-container matColumnDef="activeCall">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let lenderUser">
                    <mat-icon *ngIf="lenderUser.activeCall">phone</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="teamName">
                <th mat-header-cell *matHeaderCellDef></th>
                <td matTooltipPosition="above" [matTooltip]="lenderUser.teamName" mat-cell *matCellDef="let lenderUser"> {{ lenderUser.teamName | truncate: 18 }} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: columnsToDisplay"
                [ngClass]="{'highlightLenderUser': selectedLenderUserIndex === row.lenderUserId}"
                (click)="selectLenderUser(row)"
            ></tr>
            
        </table>
    </div>
    <div *ngIf="transferCallForm.valid && transferCallForm?.controls?.phone?.value?.phone" class="transfer-info-button-window">
        <div class="selected-lender-user">

            <span *ngIf="selectedLenderUserIndex && showLendioDirectory" class="selected-user-name">{{ selectedUserName | truncate: 15 }}</span>
                <span *ngIf="selectedLenderUserIndex && showLendioDirectory" class="selected-team-name">{{ selectedTeamName | truncate: 15 }}</span>

            <span *ngIf="!selectedLenderUserIndex && showLendioDirectory" class="selected-user-name">Unknown Number</span>

        </div>
        <mat-spinner
            diameter="24"
            class="transfer-button-is-processing"
            *ngIf="callStateIsProcessing">
        </mat-spinner>
        <button
            *ngIf="!callStateIsProcessing && (type === 'Cold Transfer')"
            class="transfer-button"
            type="submit"
            mat-flat-button
            [disabled]="!transferCallForm.valid || !transferCallForm?.controls?.phone?.value?.phone"
            (click)="processColdTransfer(call.callId)"
        >Transfer</button>
        <button
            *ngIf="!callStateIsProcessing && (type === 'Warm Transfer')"
            class="transfer-button"
            type="submit"
            mat-flat-button
            [disabled]="!transferCallForm.valid || !transferCallForm?.controls?.phone?.value?.phone"
            (click)="processWarmTransfer(call.callId)"
        >Add call</button>
    </div>
</div>
